<template>
    <v-container fluid fill-height>
        <Headful title="Aanvraag versturen"></Headful>
        <Header color="white" show-logo :dark="false" extended></Header>
        <v-layout align-center justify-center>
            <v-flex>
                <p v-if="loading" class="text-center my-7">
                    <v-icon large color="primary">fal fa-spinner-third fa-spin</v-icon>
                </p>
                <v-alert v-else-if="notFound" dark color="error" class="text-center my-7">
                    Deze link is niet (meer) geldig.
                </v-alert>
                <div v-else class="px-5">
                    <v-card class="elevation-0 mx-auto" max-width="640">
                        <v-card-text class="pa-7">
                            <h1 class="text-h5 mb-5 text-center">Aanvraag versturen</h1>

                            <v-simple-table class="mb-5">
                                <tbody>
                                    <tr><td><strong>Naam</strong></td><td>{{ request.name }}</td></tr>
                                    <tr><td><strong>Functie</strong></td><td>{{ request.function }}</td></tr>
                                    <tr><td><strong>E-mail</strong></td><td>{{ request.email }}</td></tr>
                                    <tr><td><strong>Dienstverlener</strong></td><td>{{ request.organisationName }}</td></tr>
                                    <tr><td><strong>Type dienst</strong></td><td>{{ request.typeDienst }}</td></tr>
                                </tbody>
                            </v-simple-table>

                            <v-alert v-if="success" color="success" class="mb-0">
                                Je aanvraag is verstuurd naar de dienstverlener. Zij geven de verwachte
                                start- en einddatum door.
                            </v-alert>
                            <div v-else-if="request.status === 'approved'">
                                <p class="text-center mb-4">Verstuur je goedgekeurde aanvraag naar de dienstverlener.</p>
                                <v-btn color="primary" rounded block class="elevation-0" :loading="submitting" :disabled="submitting" @click="send">
                                    Versturen
                                </v-btn>
                            </div>
                            <v-alert v-else color="warning" class="mb-0">
                                Deze aanvraag is al verstuurd of kan niet (meer) verstuurd worden.
                            </v-alert>
                        </v-card-text>
                    </v-card>
                </div>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import Headful from "@/components/layout/Headful";
import Header from "@/components/layout/Header";

export default {
    name: "SubmitRequest",
    components: { Headful, Header },
    props: {
        token: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        loading: true,
        notFound: false,
        submitting: false,
        success: false,
        request: {},
    }),
    mounted() {
        this.$store.dispatch('request/fetchSubmit', { token: this.token })
            .then(request => { this.request = request; })
            .catch(e => {
                console.error(e);
                this.notFound = true;
            })
            .finally(() => { this.loading = false; });
    },
    methods: {
        send() {
            if (this.submitting) {
                return;
            }

            this.submitting = true;

            this.$store.dispatch('request/confirmSubmit', { token: this.token })
                .then(() => { this.success = true; })
                .catch(e => {
                    console.error(e);
                    this.$store.dispatch('showSnackbar', { color: 'error', text: 'De aanvraag kon niet worden verstuurd' });
                })
                .finally(() => { this.submitting = false; });
        },
    },
}
</script>
